import { META_TAG } from 'src/constants/metaTag';
import { getMetaTagContent } from './core';
import { parseKeyValuePairs } from './transform';

export interface MetaTagData {
  weblabTreatments: Record<string, string>;
}

/**
 * Retrieves and structures all meta tag data from our HTML document.
 *
 * This function is typically called during application initialization to populate
 * the Redux store with meta tag-based configurations.
 *
 * @returns Object containing structured meta tag data
 * @property {Record<string, string>} weblabTreatments - Mapping of weblab IDs to treatments.
 *                                                         Returns empty object if no treatments found.
 *
 * @example
 * const metaData = getAllMetaTagData();
 * store.dispatch(weblabsActions.setWeblabs(metaData.weblabTreatments));
 *
 */
export const getAllMetaTagData = () => {
  // Retrieve weblab treatments
  const weblabContent = getMetaTagContent(META_TAG.MONS_WEBLAB);
  const weblabTreatments = weblabContent ? parseKeyValuePairs(weblabContent) : {};

  const metaTagData: MetaTagData = {
    weblabTreatments,
  };
  return metaTagData;
};

/** Initial meta tag data processed during module initialization. Instantiated once and shared across imports. */
const InitialMetaTagData = getAllMetaTagData();
export default InitialMetaTagData;
